function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import { UploadFile } from './UploadFile';
import { Label } from '../Label';
import { Stack } from '../Stack';
import { ProgressIndicator } from '../ProgressIndicator';
import { useBlobContainerUpload } from './useBlobContainerUpload';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function BlobContainerUpload(_ref) {
  let {
    containerUrl,
    path,
    accept = 'image/*,.pdf,.xls,.xlsx,.docx,.doc,.csv',
    onComplete,
    onProgress,
    onError,
    blacklist,
    disabled,
    style = {
      padding: '10px',
      height: '100%'
    },
    label = "Drag 'n' drop some files here, or click to select files",
    maxFilesNumber,
    filesNumber,
    fileValidator,
    fileCompleteIcon
  } = _ref;
  const {
    completed,
    failed,
    succeeded,
    acceptedFiles,
    validating,
    getRootProps,
    getInputProps,
    setCompleted,
    setFailed,
    setSucceeded
  } = useBlobContainerUpload({
    blacklist,
    fileValidator,
    maxFilesNumber,
    filesNumber,
    accept,
    onComplete,
    onError,
    onProgress
  });
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, getRootProps()), {}, {
    style: disabled ? _objectSpread(_objectSpread({}, style), {}, {
      opacity: '0.6',
      pointerEvents: 'none'
    }) : style,
    children: [/*#__PURE__*/_jsx("input", _objectSpread(_objectSpread({}, getInputProps()), {}, {
      disabled: disabled
    })), !acceptedFiles || acceptedFiles.length === 0 && /*#__PURE__*/_jsx(Stack, {
      children: validating ? /*#__PURE__*/_jsx(ProgressIndicator, {
        label: 'Validating files'
      }) : /*#__PURE__*/_jsx(Label, {
        children: label
      })
    }), /*#__PURE__*/_jsx(Stack, {
      tokens: {
        childrenGap: 10
      },
      children: acceptedFiles.map(file => /*#__PURE__*/_jsx(UploadFile, {
        completeIcon: fileCompleteIcon,
        preventUpload: file.blacklisted,
        containerUrl: containerUrl,
        path: path,
        file: file,
        onComplete: upload => {
          if (!upload.error) {
            succeeded.push(upload);
            setSucceeded([...succeeded]);
          }
          completed.push(upload);
          setCompleted([...completed]);
        },
        onError: upload => {
          failed.push(upload);
          setFailed([...failed]);
        }
      }, file.name))
    })]
  }));
}